import React from 'react';
import { Field } from 'formik';
import Label from '../label/label';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';

export const LoginDetails = () => {
    const { translate } = useLocale();

    return (
        <>
            <div className="flex flex-row">
                <div className="flex flex-col flex-1 pr-3">
                    <Label htmlFor='firstName'
                        className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.firstName)}:</Label>
                    <Field
                        disabled
                        name="firstName"
                        type="text"
                        className="flex bg-gray-inputflex flex-row items-center p-1 text-gray-500 text-sm w-full bg-gray-input cursor-not-allowed" />
                </div>
                <div className="flex flex-col flex-1 pl-3">
                    <Label htmlFor='lastName'
                        className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.lastName)}:</Label>
                    <Field
                        disabled
                        name="lastName"
                        type="text"
                        className="flex bg-gray-inputflex flex-row items-center p-1 text-gray-500 text-sm w-full bg-gray-input cursor-not-allowed" />
                </div>
            </div>

        </>);
};
